<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">调拨单详情</span>
  </a-card>
  <a-card :bordered="false">
    <a-descriptions title="调拨单操作" class="width80" :column='5'>
      <a-descriptions-item label="订单状态">{{orderData.allocation_status_text}}</a-descriptions-item>
      <a-descriptions-item label="调拨单号" :span='4'>{{orderData.allocation_sn}}</a-descriptions-item>
      <a-descriptions-item label="备注" :span='5'>{{orderData.remark}}</a-descriptions-item>
      <a-descriptions-item label="拒绝原因" :span='5' v-if='orderData.allocation_status == 7 || orderData.allocation_status == 8'>{{orderData.refuse_reason}}</a-descriptions-item>
      <a-descriptions-item label="申请原因" :span='5' v-if='orderData.allocation_status == 4'>{{orderData.refuse_reason}}</a-descriptions-item>
    </a-descriptions>
    <!-- 1：待接收 2:经销商接受调拨 3：订单关闭 4：经销商申请关闭 5：已出货 6：已签收 7：总部拒绝关闭订单 -->
    <div class="m-t-10 p-b-10">
      <a-button @click='showLog = true'>查看操作记录</a-button>
      <a-button class="width-100 m-l-20" block type="primary" @click='closeOrder' v-if='orderData.allocation_status == 1'>关闭订单</a-button>
      <a-button class="width-100 m-l-20" block type="primary" @click='visible = true' v-if='orderData.allocation_status == 4'>处理订单</a-button>
    </div>
    <a-descriptions title="创建人详情" :column='1' class="m-t-20">
      <a-descriptions-item label="创建人">{{orderData.create_role_name}}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{orderData.create_create_role_phone}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="出库单详情" :column='1' class="m-t-20">
      <a-descriptions-item label="调出经销商">{{orderData.from}}</a-descriptions-item>
      <a-descriptions-item label="调入经销商">{{orderData.to}}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{orderData.create_time}}</a-descriptions-item>
      <a-descriptions-item label="出货时间" v-if='orderData.allocation_status == 6 || orderData.allocation_status == 5'>{{orderData.out_warehousing_time}}</a-descriptions-item>
      <a-descriptions-item label="关联出库单" v-if='orderData.allocation_status == 6 || orderData.allocation_status == 5'>{{orderData.out_warehousing_sn}}</a-descriptions-item>
      <a-descriptions-item label="签收时间" v-if='orderData.allocation_status == 6'>{{orderData.signing_time}}</a-descriptions-item>
    </a-descriptions>
    <div class="fz-16 s_font_b m-t-20">商品详情</div>
    <a-table class='m-t-25' :pagination='false' bordered rowKey='product_sn' :columns='columns'
      :data-source='goodList'>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
      <template v-slot:out_warehousing_num="{ record }">
        <a-input-number style='width: 100%;' v-model:value="record.out_warehousing_num" :precision='0' :min='1' placeholder='请输入数量' :disabled="orderData.allocation_status != 1" /><p v-if='record.fail' style='color:#ff4d4f'>请输入调拨数量！</p>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="link" @click='showCode = true;itemId = record.id'>查看出货二维码</a-button>
      </template>
    </a-table>
    <div class="m-t-25" v-if='orderData.allocation_status == 1'>
      <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
      <a-button class="width-100" block type="primary" @click="onSubmit">保存</a-button>
    </div>
  </a-card>
  <a-modal :keyboard="false" title="处理订单" centered v-model:visible="visible" :confirm-loading="confirmLoading" destroyOnClose @ok='handle'>
    <a-form-item label="是否同意关闭订单">
      <a-radio-group v-model:value="apply">
        <a-radio :value="1">同意</a-radio>
        <a-radio :value="0">拒绝</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="拒绝原因" v-if='apply == 0'>
      <a-textarea v-model:value="reason" placeholder="请填写拒绝原因，限100字内" :rows="4" :maxlength='100' style="width: 350px;" />
    </a-form-item>
  </a-modal>
  <a-modal :keyboard="false" title="出货二维码" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <shippingCode :id='itemId' :showLast='true' :sn='$route.query.id' type='allocation'></shippingCode>
  </a-modal>
  <a-modal :keyboard="false" title="协商记录" :width='1300' centered v-model:visible="showLog" destroyOnClose :footer='null'>
    <consultLog :id='$route.query.id'></consultLog>
  </a-modal>
</template>

<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
  import { message } from "ant-design-vue";
  import store from "@/store";
  import { getAllocationMore,closeAllocation, handelAllocation,editAllocation } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import shippingCode from '../../components/shippingCode.vue' 
  import consultLog from '../../components/consultLog.vue' 
  export default {
    components: { LeftOutlined,shippingCode,consultLog },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        orderData: {},
        goodList: [],
        showCode:false, //是否显示出货二维码
        itemId:'', //查看出货二维码商品id
        showLog:false, //是否显示协商记录
        visible:false, //是否显示处理订单
        confirmLoading:false, //处理订单loading状态
        apply:1, //处理订单是否同意
        reason:'', //处理订单拒绝理由
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "数量",
            dataIndex: "out_warehousing_num",
            key: "out_warehousing_num",
            slots: { customRender: "out_warehousing_num" },
          },
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getAllocationMore($route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          if(res.data.out_warehousing_status == 6 || res.data.out_warehousing_status == 5){ // 5：已出货6：已签收，商品列表显示操作栏
            state.columns.push({
              title: "操作",
              key: "action",
              slots: { customRender: "action" }
            })
          }
          state.orderData = res.data;
          state.goodList = res.data.product
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //修改数量
      const onSubmit = async() =>{
        var product = []
        state.goodList.forEach(v=>{ // 判断调拨数量是否全部输入完毕，拼接提交数据
          v.fail = false
          if(!isNumber(v.out_warehousing_num)){
            v.fail = true
          } 
          product.push(v.product_id+'_'+(v.product_sku_sn?v.product_sku_sn:0)+'_'+(v.out_warehousing_num?v.out_warehousing_num:0))
        })
        if(state.goodList.findIndex(v=> v.fail ) !== -1){
          message.error('请输入调拨数量!');
          return false
        }
        const hide = message.loading("正在加载中...", 0);
        let res = await editAllocation({ product:product,sn: $route.query.id}).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          message.success(res.msg);
          setTimeout(() => {
            $router.go(-1);
          }, 2000);
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      // 关闭
      const closeOrder = () => {
        $Modal.confirm({
          centered: true,
          title:'确定关闭订单？',
          content: '订单关闭后将无法开启',
          onOk: async () => {
            let res = await closeAllocation($route.query.id).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      // 处理订单
      const handle = async () => {
        if(state.apply == 0 && state.reason == ''){
          message.error('请填写拒绝理由！');
          return
        }
        let res = await handelAllocation({sn:$route.query.id,apply:state.apply,reason:state.reason}).then((res) => res.data);
        if (iscode(res, true)) {
          initData();
        }
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        closeOrder,
        handle,
        onSubmit
      };
    },
  };
</script>